import { render, staticRenderFns } from "./MyProfileCollect.vue?vue&type=template&id=e12fb606&scoped=true"
import script from "./MyProfileCollect.vue?vue&type=script&lang=js"
export * from "./MyProfileCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12fb606",
  null
  
)

export default component.exports